export const LOCALE = 'LOCALE';
export const LOCATION = 'LOCATION';
export const ACCESS_TOKEN = 'ACCESS_TOKEN';
export const REFRESH_TOKEN = 'REFRESH_TOKEN';
export const ALL = 'all';
export const DEFAULT_PAGE_SIZE = Number(
  process.env.VUE_APP_PAGE_SIZE || 10
);
export const CUSTOMER = 'CUSTOMER';
export const CHANNEL = 'CHANNEL';
